import React from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import styled from 'styled-components'

const ToastProvider = () => {
  let isBuyCrypto = false
  if (typeof window !== 'undefined') isBuyCrypto = window.location.pathname === '/buy-crypto'

  return !isBuyCrypto && <StyledToastContainer closeButton={false} />
}

export default ToastProvider

const StyledToastContainer = styled(ToastContainer)`
  &&&.Toastify__toast-container {
    width: auto;
    min-width: 320px;
    padding: 0;
    z-index: 9999999999;
    bottom: 0;
    pointer-events: none;
  }
  .Toastify__toast {
    padding: 0;
    border-radius: 8px;
  }
  .Toastify__toast-body {
    padding: 0;
  }
  .Toastify__progress-bar {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 8px;
    margin: 4px;
  }

  .cookie-police-classes {
    &__toast {
      border-radius: 4px;
      bottom: 56px;
      pointer-events: all;

      @media (max-width: 539px) {
        bottom: 78px;
        width: 100vw;
      }
    }
  }

  .copytrading-banner-classes {
    &__toast {
      border-radius: 8px;
      bottom: 56px;
      left: -7px;
      max-width: 520px;
      height: 310px;
      pointer-events: all;

      @media (max-width: 539px) {
        max-width: 320px;
        height: 202px;
        bottom: 78px;
        left: -15px;
      }

      @media (max-width: 480px) {
        bottom: 96px;
        left: 3px;
      }
    }
  }

  .error {
    &__body {
      padding: 25px;
    }
  }
`
